import { NeoModel, Attributes, ModelBase, Misc } from '@singularsystems/neo-core';

@NeoModel
export default class DividendTransactionsLookup extends ModelBase {
  
  public brokerAccountNumber: string = "";

  public instrument: string = "";

  public eventDetail: string = "";

  public eventId: string = "";

  @Attributes.Date(Misc.TimeZoneFormat.None)
  public eventDate: Date = new Date();

  public amountNC: number | null = null;

  public excluded: boolean | null = null;
}